
import React, { useState } from 'react';
import { useLang } from '@/contexts/LangContext';
import { Language, translations } from '@/translations/okx';
import { Globe } from 'lucide-react';
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from '@/components/ui/dropdown-menu';

const LanguageSelector = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);

  const languageNames: Record<Language, string> = {
    en: 'English',
    ru: 'Русский',
    tr: 'Türkçe',
    es: 'Español',
    pt: 'Português',
    de: 'Deutsch'
  };

  const handleSelectLanguage = (language: Language) => {
    setLang(language);
    // Explicitly set the okx_prefLang to ensure it's updated
    localStorage.setItem('okx_prefLang', language);
    setOpen(false);
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <DropdownMenu open={open} onOpenChange={setOpen}>
        <DropdownMenuTrigger className="flex items-center gap-2 bg-black/50 backdrop-blur-md px-3 py-2 rounded-lg border border-gray-700 hover:bg-black/70 transition-colors">
          <Globe size={16} />
          <span>{languageNames[lang]}</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="bg-black/90 border-gray-700">
          {Object.keys(translations).map((langKey) => (
            <DropdownMenuItem
              key={langKey}
              className={`cursor-pointer hover:bg-gray-800 ${langKey === lang ? 'bg-gray-800' : ''}`}
              onClick={() => handleSelectLanguage(langKey as Language)}
            >
              {languageNames[langKey as Language]}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default LanguageSelector;
